import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { History, Location } from 'history'
import { Container, FullWidthContainerBody } from 'uiComponents/settingsContainer'
import UploadReservationsPage from 'venue/bookingCodes/reservationCodePools/uploadReservationsPage'
import { UploadSeasonPassesPage } from 'venue/bookingCodes/uploadSeasonPassesPage'
import BarcodePoolsPage from 'venue/bookingCodes/barcodePools'
import ReservationCodePoolsPage from 'venue/bookingCodes/reservationCodePools'
import UploadBarcodesPage from 'venue/bookingCodes/barcodePools/uploadBarcodesPage'
import ProductIdsPage from 'venue/bookingCodes/productIdsPage'
import { ArticleService } from 'admin/articleService'
import { BookingCodesService } from 'venue/bookingCodes/bookingCodesService'
import { withFeatures } from 'features'
import { LoginService } from 'http/loginService'
import CodesTabsNavigation from './navigation'
import CodesHeading from './heading'
import { useBookingNavigation } from './hooks'
import BaseKnowledgeLink from 'uiComponents/typography/BaseKnowledgeLink'
import { useMessages } from 'messagesContext'

interface VouchersPageProps {
    history: History
    accountSlug: string
    location: Location
    articleService: ArticleService
    bookingCodesService: BookingCodesService
    backofficeEndpoint: string
    loginService: LoginService
    hasFeature: (feature: string, accountSlug: string) => boolean
}

function VouchersPage(props: VouchersPageProps) {
    const reservationPoolsOn = props.hasFeature('RetailersReservationCodes', props.accountSlug)
    const { replaceMessages, removeAllMessages } = useMessages()
    const sections = useBookingNavigation()
    const activeSection = sections.find((section) => section.active)
    
    return (
        <div style={{ position: 'relative' }} id="codes">
            <CodesHeading activeSection={activeSection} />
            <Container style={{ maxWidth: '75rem', marginBottom: 0 }}>
                <CodesTabsNavigation sections={sections}/>
                <Switch location={props.location}>
                    <Route
                        path="/account/:accountSlug/venue/codes/tickets/list"
                        render={() => (
                            <FullWidthContainerBody>
                                <BarcodePoolsPage
                                    bookingCodesService={props.bookingCodesService}
                                    accountSlug={props.accountSlug}
                                    replaceMessages={replaceMessages}
                                    removeAllMessages={removeAllMessages}
                                    history={props.history}
                                />
                            </FullWidthContainerBody>
                        )}
                    />
                    <Route
                        path="/account/:accountSlug/venue/codes/tickets/upload/:poolId"
                        render={() => (
                            <FullWidthContainerBody>
                                <UploadBarcodesPage
                                    history={props.history}
                                    bookingCodesService={props.bookingCodesService}
                                    loginService={props.loginService}
                                    backofficeEndpoint={props.backofficeEndpoint}
                                    accountSlug={props.accountSlug}
                                    replaceMessages={replaceMessages}
                                    removeAllMessages={removeAllMessages}
                                />
                            </FullWidthContainerBody>
                        )}
                    />
                    {!reservationPoolsOn && (
                        <Route
                            path="/account/:accountSlug/venue/codes/reservations"
                            render={() => (
                                <FullWidthContainerBody>
                                    <UploadReservationsPage
                                        history={props.history}
                                        bookingCodesService={props.bookingCodesService}
                                        loginService={props.loginService}
                                        backofficeEndpoint={props.backofficeEndpoint}
                                        accountSlug={props.accountSlug}
                                        replaceMessages={replaceMessages}
                                        removeAllMessages={removeAllMessages}
                                    />
                                </FullWidthContainerBody>
                            )}
                        />
                    )}
                    {reservationPoolsOn && (
                        <Route
                            path="/account/:accountSlug/venue/codes/reservations/list/"
                            render={() => (
                                <FullWidthContainerBody>
                                    <ReservationCodePoolsPage
                                        bookingCodesService={props.bookingCodesService}
                                        loginService={props.loginService}
                                        backofficeEndpoint={props.backofficeEndpoint}
                                        accountSlug={props.accountSlug}
                                        replaceMessages={replaceMessages}
                                        removeAllMessages={removeAllMessages}
                                        history={props.history}
                                    />
                                </FullWidthContainerBody>
                            )}
                        />
                    )}
                    {reservationPoolsOn && (
                        <Route
                            path="/account/:accountSlug/venue/codes/reservations/upload/:poolId"
                            render={() => (
                                <FullWidthContainerBody>
                                    <UploadReservationsPage
                                        history={props.history}
                                        bookingCodesService={props.bookingCodesService}
                                        loginService={props.loginService}
                                        backofficeEndpoint={props.backofficeEndpoint}
                                        accountSlug={props.accountSlug}
                                        replaceMessages={replaceMessages}
                                        removeAllMessages={removeAllMessages}
                                    />
                                </FullWidthContainerBody>
                            )}
                        />
                    )}
                    <Route
                        path="/account/:accountSlug/venue/codes/sold_tickets"
                        render={() => (
                            <FullWidthContainerBody>
                                <UploadSeasonPassesPage
                                    bookingCodesService={props.bookingCodesService}
                                    loginService={props.loginService}
                                    backofficeEndpoint={props.backofficeEndpoint}
                                    accountSlug={props.accountSlug}
                                    replaceMessages={replaceMessages}
                                    removeAllMessages={removeAllMessages}
                                />
                            </FullWidthContainerBody>
                        )}
                    />
                    <Route
                        path="/account/:accountSlug/venue/codes/product_ids"
                        render={() => (
                            <FullWidthContainerBody>
                                <ProductIdsPage
                                    history={props.history}
                                    accountSlug={props.accountSlug}
                                    articleService={props.articleService}
                                    replaceMessages={replaceMessages}
                                />
                            </FullWidthContainerBody>
                        )}
                    />                
                    <Route render={() => <Redirect to={`/account/${props.accountSlug}/venue/codes/tickets/list`} />} />
                </Switch>
            </Container>
            {activeSection?.guidelinesUrl && <BaseKnowledgeLink link={activeSection.guidelinesUrl} />}
        </div>
    )
}

export default withFeatures(VouchersPage)
